/* DARMA email pop-up (FINAL, Oct 2 2026).
   Opens once: 8s after the page has loaded, or at 50% scroll, or on exit intent (desktop pointer leaving the top).
   Never on the homepage while the logo intro is playing, never over an open drawer.
   Dismissed: hidden 7 days, and the 10% OFF side tab takes its place until sign-up (Derek R3, direction A).
   Signed up, or arrived from a Klaviyo email: hidden for good. Storage is best effort (try/catch, cookie fallback).
   Subscribes through Klaviyo's client API (public key only) to the Email List; the list triggers the
   welcome flow that sends the code. Also publishes `darma_email_signup` to Shopify customer events. */
(function () {
  'use strict';
  var root = document.getElementById('DarmaEmailPopup');
  if (!root || root.dataset.dpInit) return;
  root.dataset.dpInit = '1';

  var KEY_DISMISS = 'darma_popup_dismissed_at';
  var KEY_DONE = 'darma_popup_subscribed';
  var DISMISS_DAYS = 7;
  var DELAY_MS = 8000;
  var REVISION = '2026-07-15';
  var EMAIL_RE = /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)+$/;

  var cfg = {
    company: root.getAttribute('data-company'),
    list: root.getAttribute('data-list'),
    source: root.getAttribute('data-source'),
    template: root.getAttribute('data-template') || ''
  };

  /* ---------- storage (never throws) ---------- */
  function readCookie(k) {
    try {
      var m = document.cookie.match(new RegExp('(?:^|; )' + k + '=([^;]*)'));
      return m ? decodeURIComponent(m[1]) : null;
    } catch (e) { return null; }
  }
  function writeCookie(k, v, days) {
    try {
      document.cookie = k + '=' + encodeURIComponent(v) + '; path=/; max-age=' + Math.round(days * 86400) + '; SameSite=Lax';
    } catch (e) {}
  }
  function get(k) {
    var v = null;
    try { v = window.localStorage.getItem(k); } catch (e) {}
    return v !== null ? v : readCookie(k);
  }
  function set(k, v, days) {
    try { window.localStorage.setItem(k, v); } catch (e) {}
    writeCookie(k, v, days);
  }
  function clear(k) {
    try { window.localStorage.removeItem(k); } catch (e) {}
    writeCookie(k, '', -1);
  }

  /* ---------- eligibility ---------- */
  var params;
  try { params = new URLSearchParams(window.location.search); } catch (e) { params = { get: function () { return null; }, has: function () { return false; } }; }
  var force = params.get('darma_popup') === '1';
  if (params.get('darma_popup') === 'reset') { clear(KEY_DISMISS); clear(KEY_DONE); try { window.sessionStorage.removeItem('darma_offer_tab_hidden'); } catch (e) {} }
  // Arrived from a Klaviyo email: already on the list. Remembered, so the offer doesn't follow them to the next page.
  if (params.has('_kx') || params.get('utm_source') === 'klaviyo') set(KEY_DONE, '1', 3650);

  function suppressed() {
    if (force) return false;
    if (get(KEY_DONE) === '1') return true;
    var t = parseInt(get(KEY_DISMISS), 10);
    if (t && Date.now() - t < DISMISS_DAYS * 86400000) return true;
    // Arrived from a Klaviyo email: already on the list.
    if (params.has('_kx') || params.get('utm_source') === 'klaviyo') return true;
    var p = window.location.pathname;
    if (/^\/(cart|checkouts?|account|password)(\/|$)/.test(p) || /\/checkouts?\//.test(p)) return true;
    return false;
  }
  var popupOff = suppressed();   // the side tab below can still run when the pop-up itself is off

  function visible(el) {
    if (!el) return false;
    // content of a closed <details> (Dawn's search modal, menu drawer) still reports display/rects in current Chrome
    var d = el.closest && el.closest('details');
    if (d && !d.open && !el.closest('summary')) return false;
    if (typeof el.checkVisibility === 'function' && !el.checkVisibility()) return false;
    var cs = window.getComputedStyle(el);
    return cs.display !== 'none' && cs.visibility !== 'hidden' && parseFloat(cs.opacity) > 0.01 && el.getClientRects().length > 0;
  }
  function introPlaying() {
    var de = document.documentElement, b = document.body;
    if (de.classList.contains('darma-intro-active') || (b && b.classList.contains('darma-intro-active'))) return true;
    var els = document.querySelectorAll('[data-darma-intro], .darma-intro, #darma-intro, #DarmaIntro');
    for (var i = 0; i < els.length; i++) {
      if (!els[i].hidden && visible(els[i]) && els[i].getAttribute('data-darma-intro') !== 'done') return true;
    }
    return false;
  }
  function somethingElseOpen() {
    var b = document.body;
    if (!b) return true;
    if (b.classList.contains('overflow-hidden') || b.classList.contains('overflow-hidden-mobile') ||
        b.classList.contains('overflow-hidden-tablet') || b.classList.contains('overflow-hidden-desktop')) return true;
    // Shopify's cookie banner sits above everything on a phone: wait until the visitor has answered it
    var consent = document.getElementById('shopify-pc__banner');
    if (consent && visible(consent)) return true;
    var drawer = document.querySelector('cart-drawer.active, cart-drawer.is-visible, .drawer.active');
    if (drawer && visible(drawer)) return true;
    var dialogs = document.querySelectorAll('[role="dialog"][aria-modal="true"]');
    for (var i = 0; i < dialogs.length; i++) {
      if (!root.contains(dialogs[i]) && visible(dialogs[i])) return true;
    }
    return false;
  }

  /* ---------- open / close ---------- */
  var panel = root.querySelector('.dp__panel');
  var form = root.querySelector('[data-dp-form]');
  var input = root.querySelector('#DarmaEmailPopupEmail');
  var errorEl = root.querySelector('#DarmaEmailPopupError');
  var submitBtn = root.querySelector('[data-dp-submit]');
  var viewForm = root.querySelector('[data-dp-view="form"]');
  var viewDone = root.querySelector('[data-dp-view="done"]');
  var doneTitle = root.querySelector('[data-dp-done-title]');
  var reduceMotion = false;
  try { reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  var isOpen = false, shown = false, lastFocus = null, signedUp = false;

  function focusables() {
    return Array.prototype.filter.call(
      panel.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'),
      function (el) { return !el.disabled && !el.closest('[hidden]') && el.getClientRects().length > 0; }
    );
  }

  function open(reason) {
    if (isOpen || (shown && reason !== 'widget')) return;
    shown = true; isOpen = true;
    lastFocus = document.activeElement;
    root.hidden = false;
    root.setAttribute('data-dp-reason', reason || '');
    // next frame so the transition runs
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () { root.classList.add('is-open'); });
    });
    window.setTimeout(function () { try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); } }, reduceMotion ? 0 : 80);
    document.addEventListener('keydown', onKey, true);
    disarm();
    tabQueue();
  }

  function close() {
    if (!isOpen) return;
    isOpen = false;
    if (!signedUp) set(KEY_DISMISS, String(Date.now()), DISMISS_DAYS);
    root.classList.remove('is-open');
    document.removeEventListener('keydown', onKey, true);
    var done = function () { root.hidden = true; };
    if (reduceMotion) done(); else window.setTimeout(done, 420);
    var back = lastFocus;
    if (!signedUp) {
      tabShow(); tabSync();
      // focus would otherwise fall to <body>: hand it to the tab that now stands in for the pop-up
      if ((!back || back === document.body || !document.contains(back)) && tabUsable()) back = tabOpen;
    }
    if (back && typeof back.focus === 'function' && document.contains(back)) {
      try { back.focus({ preventScroll: true }); } catch (e) { back.focus(); }
    }
  }

  function onKey(e) {
    if (!isOpen) return;
    if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); e.stopPropagation(); close(); return; }
    if (e.key === 'Tab') {
      var f = focusables();
      if (!f.length) { e.preventDefault(); return; }
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || !panel.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (document.activeElement === last || !panel.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
    }
  }

  Array.prototype.forEach.call(root.querySelectorAll('[data-dp-close]'), function (el) {
    el.addEventListener('click', function (e) { e.preventDefault(); close(); });
  });

  /* ---------- triggers ---------- */
  var timer = null, armed = true, retry = null;
  function tryOpen(reason) {
    if (!armed || shown) return;
    if (introPlaying() || somethingElseOpen()) {
      // wait and try again; the reason is kept
      window.clearTimeout(retry);
      retry = window.setTimeout(function () { tryOpen(reason); }, 1000);
      return;
    }
    open(reason);
  }
  function onScroll() {
    var h = document.documentElement.scrollHeight - window.innerHeight;
    if (h > 0 && window.scrollY / h >= 0.5) tryOpen('scroll');
  }
  function onExit(e) {
    if (e.relatedTarget || e.toElement) return;
    if (e.clientY <= 0) tryOpen('exit');
  }
  function disarm() {
    armed = false;
    window.clearTimeout(timer); window.clearTimeout(retry);
    window.removeEventListener('scroll', onScroll);
    document.removeEventListener('mouseout', onExit);
  }

  if (force) {
    tryOpen('preview');
  } else if (!popupOff) {
    // 8 seconds after the page has finished loading
    var startTimer = function () { timer = window.setTimeout(function () { tryOpen('time'); }, DELAY_MS); };
    if (document.readyState === 'complete') startTimer(); else window.addEventListener('load', startTimer, { once: true });
    window.addEventListener('scroll', onScroll, { passive: true });
    var finePointer = false;
    try { finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches; } catch (e) {}
    if (finePointer) {
      // exit intent only after the visitor has been here a few seconds
      window.setTimeout(function () { if (armed) document.addEventListener('mouseout', onExit); }, 3000);
    }
  }

  /* ---------- 10% OFF side tab (Derek R3, direction A) ----------
     After the pop-up has been closed: on every page and later visits until sign-up. Tap reopens the pop-up.
     x hides it for the rest of the visit (sessionStorage). Same exclusions as the pop-up (cart, checkout, account,
     password, signed-in subscribers, Klaviyo email visitors). Steps aside while the homepage intro plays, while a
     drawer, the menu, search or the cookie banner is open, and while ADD TO CART is (about to be) underneath it. */
  var KEY_TAB_HIDDEN = 'darma_offer_tab_hidden';
  var ATC = '[id^="ProductSubmitButton-"], .shopify-payment-button, [data-dsc-add], [data-darma-atc]';
  var tab = document.getElementById('DarmaOfferWidget');
  var tabOpen = tab && tab.querySelector('[data-dpw-open]');
  var tabOn = false, tabTick = null, tabRaf = false;

  function tabAllowed() {
    if (!tab || signedUp || get(KEY_DONE) === '1') return false;
    if (params.has('_kx') || params.get('utm_source') === 'klaviyo') return false;
    var p = window.location.pathname;
    if (/^\/(cart|checkouts?|account|password)(\/|$)/.test(p) || /\/checkouts?\//.test(p)) return false;
    try { if (window.sessionStorage.getItem(KEY_TAB_HIDDEN) === '1') return false; } catch (e) {}
    return !!get(KEY_DISMISS);
  }
  function tabUsable() { return tabOn && !tab.hidden && !tab.classList.contains('is-away'); }
  function cssReady() { var l = document.getElementById('DarmaEmailPopupCss'); return !l || l.media !== 'print'; }
  // ADD TO CART inside the tab's place on screen (plus a buffer, so a fast scroll can't carry it under the tab)
  function overAtc() {
    var els = document.querySelectorAll(ATC);
    if (!els.length) return false;
    var vw = document.documentElement.clientWidth, mid = window.innerHeight / 2, half = tab.offsetHeight / 2 + 72;
    var left = vw - tab.offsetWidth - 8;
    for (var i = 0; i < els.length; i++) {
      var r = els[i].getBoundingClientRect();
      if (r.width && r.height && r.right > left && r.left < vw && r.bottom > mid - half && r.top < mid + half) return true;
    }
    return false;
  }
  function tabSync() {
    tabRaf = false;
    if (!tabOn) return;
    if (!tabAllowed()) { tabHide(); return; }
    if (!cssReady()) return;
    if (tab.hidden) { tab.hidden = false; void tab.offsetWidth; }   // starts off the edge (is-away), then slides in
    tab.classList.toggle('is-away', isOpen || introPlaying() || somethingElseOpen() || overAtc());
  }
  function tabQueue() { if (tabOn && !tabRaf) { tabRaf = true; window.requestAnimationFrame(tabSync); } }
  function tabShow() {
    if (tabOn || !tabAllowed()) return;
    tabOn = true;
    tab.classList.add('is-away');
    tabTick = window.setInterval(tabSync, 400);
    window.addEventListener('scroll', tabQueue, { passive: true });
    window.addEventListener('resize', tabQueue);
    tabQueue();
  }
  function tabHide() {
    tabOn = false;
    if (!tab) return;
    tab.hidden = true;
    window.clearInterval(tabTick);
    window.removeEventListener('scroll', tabQueue);
    window.removeEventListener('resize', tabQueue);
  }
  if (tab) {
    tabOpen.addEventListener('click', function () { open('widget'); });
    tab.querySelector('[data-dpw-hide]').addEventListener('click', function () {
      try { window.sessionStorage.setItem(KEY_TAB_HIDDEN, '1'); } catch (e) {}
      tabHide();
    });
    tabShow();
  }

  /* ---------- submit ---------- */
  function setError(msg) {
    errorEl.textContent = msg || '';
    if (msg) input.setAttribute('aria-invalid', 'true'); else input.removeAttribute('aria-invalid');
  }
  input.addEventListener('input', function () { if (input.getAttribute('aria-invalid')) setError(''); });

  function payload(email) {
    return {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: cfg.source,
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
              }
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: cfg.list } } }
      }
    };
  }

  function publish(email) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('darma_email_signup', {
          source: cfg.source,
          list_id: cfg.list,
          page_type: cfg.template,
          page_path: window.location.pathname
        });
      }
    } catch (e) {}
    try {
      // tie this browser to the new profile so browse and cart flows can reach it
      if (window.klaviyo && typeof window.klaviyo.identify === 'function') window.klaviyo.identify({ email: email });
    } catch (e) {}
  }

  var sending = false;
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (sending) return;
    var email = (input.value || '').trim();
    if (!email) { setError('Enter your email address.'); input.focus(); return; }
    if (!EMAIL_RE.test(email) || email.length > 254) { setError('Enter a valid email address.'); input.focus(); return; }
    setError('');
    sending = true;
    submitBtn.disabled = true;
    submitBtn.setAttribute('aria-busy', 'true');

    var url = 'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(cfg.company);
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', 'Accept': 'application/vnd.api+json', 'revision': REVISION },
      body: JSON.stringify(payload(email))
    }).then(function (res) {
      if (!(res.status === 202 || res.status === 200 || res.status === 201)) throw new Error('status ' + res.status);
      signedUp = true;
      set(KEY_DONE, '1', 3650);
      publish(email);
      viewForm.hidden = true;
      viewDone.hidden = false;
      root.setAttribute('data-dp-state', 'done');
      panel.setAttribute('aria-labelledby', 'DarmaEmailPopupDone');
      panel.setAttribute('aria-describedby', 'DarmaEmailPopupDoneLine');
      doneTitle.id = 'DarmaEmailPopupDone';
      try { doneTitle.focus({ preventScroll: true }); } catch (err) { doneTitle.focus(); }
    }).catch(function () {
      setError('That did not go through. Please try again.');
      submitBtn.disabled = false;
      submitBtn.removeAttribute('aria-busy');
      input.focus();
    }).then(function () { sending = false; });
  });
})();
